var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-screen",attrs:{"id":"app"}},[_c('router-view'),_c('up-arrow',{staticClass:"up-arrow cursor-pointer",class:{ 'hide-arrow': !_vm.showArrow },nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }